<template>
  <div class="ncrm-contracts-board-scope">
    <span class="ncrm-contracts-board-scope__label">
      {{ $t("ncrm.contracts.home.boardScopes.label") }}
    </span>
    <NcrmSegmentedControl
      :model-value="modelValue"
      :items="items"
      :aria-label="$t('ncrm.contracts.home.boardScopes.label')"
      block
      @update:model-value="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script>
import NcrmSegmentedControl from "@/components/ncrm/shared/NcrmSegmentedControl.vue";

export default {
  name: "NcrmContractsBoardScopeToggle",
  components: {
    NcrmSegmentedControl,
  },
  props: {
    modelValue: {
      type: String,
      default: "active_work",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
};
</script>

<style scoped>
.ncrm-contracts-board-scope {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

/* Calm eyebrow label, aligned with the section-eyebrow treatment used across NCRM */
.ncrm-contracts-board-scope__label {
  color: rgba(var(--v-theme-on-surface), 0.55);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

@media (max-width: 720px) {
  .ncrm-contracts-board-scope {
    width: 100%;
  }
}
</style>
